export default __webpack_public_path__ + "static/concrete-removal-single-0e4a5d2c9b7b3c01211e63222f705c54.jpg";